import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { SelectDateRange } from "commons";
import {
    CURRENT_TAX,
    LAST_TAX,
    THREE_MONTHS,
    SIX_MONTHS,
    TWELVE_MONTHS,
    THREE_YEARS,
    FIVE_YEARS,
    ALL_DATES
} from "commons/src/NuDateUtils";
import { EFFECTIVE_EVENT as DEFAULT_DATE_TYPE } from "commons/src/constants/dateConstants";
import { InfoDetail, InfoPopover, useInfoPopover } from "commons/src/InfoPopover";

import { DateTypePicker } from "./DateTypePicker";
import { getDescription, labels } from "./DateTypePickerDescription";

export const dateRanges = {
    CURRENT_TAX_YEAR: "Current tax year",
    LAST_TAX_YEAR: "Last tax year",
    LAST_3_MONTHS: "Last 3 months",
    LAST_6_MONTHS: "Last 6 months",
    LAST_12_MONTHS: "Last 12 months",
    LAST_3_YEARS: "Last 3 years",
    LAST_5_YEARS: "Last 5 years",
    ALL_DATES: "All dates"
};

const ranges = {
    [dateRanges.CURRENT_TAX_YEAR]: [CURRENT_TAX.startDate, CURRENT_TAX.endDate],
    [dateRanges.LAST_TAX_YEAR]: [LAST_TAX.startDate, LAST_TAX.endDate],
    [dateRanges.LAST_3_MONTHS]: [THREE_MONTHS.startDate, THREE_MONTHS.endDate],
    [dateRanges.LAST_6_MONTHS]: [SIX_MONTHS.startDate, SIX_MONTHS.endDate],
    [dateRanges.LAST_12_MONTHS]: [TWELVE_MONTHS.startDate, TWELVE_MONTHS.endDate],
    [dateRanges.LAST_3_YEARS]: [THREE_YEARS.startDate, THREE_YEARS.endDate],
    [dateRanges.LAST_5_YEARS]: [FIVE_YEARS.startDate, FIVE_YEARS.endDate],
    [dateRanges.ALL_DATES]: [ALL_DATES.startDate, ALL_DATES.endDate]
};

export function SelectDateRangeWithType({ dateChanged, startDate, endDate, disabled }) {
    const [anchorElement, popoverContent, openInfoPopover, closeInfoPopover] = useInfoPopover();
    const [localDateType, setLocalDateType] = useState(null);

    useEffect(() => {
        setLocalDateType(DEFAULT_DATE_TYPE);
    }, []);

    const handleDateChanged = (event, dateRange) => {
        const dateSelection = {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            dateType: dateRange.dateType ? dateRange.dateType : localDateType,
            label: dateRange.chosenLabel
        };
        dateChanged(event, dateSelection);
    };

    const selectedDateTypeChanged = (event, selectedDateType) => {
        setLocalDateType(selectedDateType);
        handleDateChanged(event, {
            startDate,
            endDate,
            dateType: selectedDateType
        });
    };

    return (
        <FlexContainer>
            <SelectDateRange
                ranges={ranges}
                disabled={disabled}
                dateChanged={handleDateChanged}
                startDate={startDate}
                endDate={endDate}
            />
            <DateTypePicker disabled={disabled} selectedDateTypeChanged={selectedDateTypeChanged} />
            <InfoDetail onClick={e => openInfoPopover(e, getDescription(labels.dateType))} />
            <InfoPopover
                handleClose={closeInfoPopover}
                anchorEl={anchorElement}
                content={popoverContent}
                horizontalPosition="left"
            />
        </FlexContainer>
    );
}

SelectDateRangeWithType.propTypes = {
    dateChanged: PropTypes.func,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    disabled: PropTypes.bool
};

const FlexContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
`;
